var React = require('react');

function Diamond (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.999 7.504l.001-.003v-.001c0-.098-.035-.183-.083-.26l-.01-.03-5-7.001-.037-.032-.11-.095-.071-.037-.052-.027-.088-.007-.049-.011h-13l-.05.012-.088.007-.052.027-.07.037-.11.095-.037.031-5 7.001-.01.03c-.048.077-.083.162-.083.26v.001l.001.004c.001.095.035.18.082.255l.01.032 11.5 16 .077.066.06.051c.081.054.171.091.27.091s.189-.038.27-.091l.06-.051.076-.066 11.5-16 .01-.032c.048-.075.082-.16.083-.256zm-18.694-5.869l1.532 5.365h-5.365l3.833-5.365zm10.535 6.365l-3.84 13.654-3.84-13.654h7.68zm-7.424-1l3.584-5.575 3.584 5.575h-7.168zm4.5-6h4.921l-1.514 5.3-3.407-5.3zm-5.239 5.3l-1.515-5.3h4.921l-3.406 5.3zm-.556 1.7l3.63 12.905-9.276-12.905h5.646zm9.758 0h5.646l-9.276 12.905 3.63-12.905zm.284-1l1.533-5.365 3.832 5.365h-5.365z"}));
}

Diamond.defaultProps = {"version":"1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Diamond;

Diamond.default = Diamond;
